export default function getFlexIAType(type) {
  switch (type) {
    case 'WATSON':
      return 'Watson';
    case 'OPENAI':
      return 'OpenAI';
    case 'DIALOG':
      return 'Árvore de Diálogo';
    default:
      return 'Desconhecido';
  }
}
